var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column justify-end",staticStyle:{"height":"400px"}},[_c('v-card',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","color":"deviceBackground","height":"360"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }